import _objectSpread from "/root/workspace/frontend_teacher-web-xiyou_WfnQ/teacher-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import NavMenuItem from '@/layout/components/NavMenu/Item.vue';
import { constantRoutes } from '@/router/index.js';
export default {
  name: 'NavMenu',
  components: {
    NavMenuItem: NavMenuItem
  },
  data: function data() {
    return {
      routes: []
    };
  },
  computed: {
    firstLevelCompositionModuleId: function firstLevelCompositionModuleId() {
      return this.$store.getters.firstLevelCompositionModuleId;
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    }
  },
  watch: {
    firstLevelCompositionModuleId: {
      handler: function handler() {
        var _this = this;
        this.routes = constantRoutes.filter(function (item) {
          if (item.path !== '/composition') return true;
          return Boolean(_this.firstLevelCompositionModuleId);
        });
      },
      immediate: true
    }
  },
  methods: {
    hasOneShowingChild: function hasOneShowingChild() {
      var _this2 = this;
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var showingChildren = children.filter(function (item) {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          _this2.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = _objectSpread(_objectSpread({}, parent), {}, {
          path: '',
          noShowingChildren: true
        });
        return true;
      }
      return false;
    },
    menuPermission: function menuPermission(item) {
      var superAdmin = sessionStorage.getItem('superAdmin');
      if (item.admin) {
        return superAdmin === '2';
      } else {
        return !item.hidden;
      }
    },
    // 选择目录
    handleSelect: function handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};